module.exports = __webpack_public_path__ + "img/but_multiple_cancelbet.8dfef0f1.png";